


  <div class="Dialog-body">
    <div class="modal-header">   
      <div class="sc-badge sc-safe" style="padding: 4px 3px !important;">{{QuestionName}}</div>
  </div>

  <img style="width:100px; height:100px" *ngIf="Image" [src]="sanitize(Image)">
    <div class="sc-icon">
      <i class="material-icons">add</i>
      <span style="padding-left: 8px;">Pick a different photo</span>
      <input type="file" accept="image/*" (change)="onSelectPhoto($event)" > 
    </div>


    

  
    <div class="buttonbelow">
      <button mat-button (click)="saveImage()">Submit</button>
      <button mat-button  (click)="DialogClose()" >Cancel</button>    
    </div>
     
 

</div>
